import { OrgFeatureFlagTypes } from '../orgFeatureFlagTypes';
export const orgFeatureFlagSchema = {
    $id: 'urn:wisepipe-domain-authorize:OrgFeatureFlag',
    type: 'object',
    properties: {
        flagName: { type: 'string', enum: Object.values(OrgFeatureFlagTypes) },
        flagValue: { type: 'string' },
        objectId: { type: 'string' },
        objectType: { type: 'string' }
    },
    required: ['flagName', 'flagValue']
};
//# sourceMappingURL=orgFeatureFlag.js.map